export function formatStringDuration (duration) {
  var hours = Math.floor(duration / 60)
  var hour = ''
  if (hours === 0) {
    hour = ''
  } else {
    hour = hours + 'h '
  }
  var minutes = Math.round(duration % 60)
  return hour + minutes + 'min'
}

export function formatNumberDuration (duration) {
  return (duration / 60).toLocaleString('de-DE', {'minimumFractionDigits': 2})
}

function padZeroes (str) {
  return str.toLocaleString('de-DE', {'minimumIntegerDigits': 2})
}

export function formatTimeStringDuration (duration) {
  var hours = Math.floor(duration / 60)
  var minutes = duration % 60

  return padZeroes(hours) + ":" + padZeroes(minutes)
}
